import { ApiResponse, getAxiosClient, makeApiRequest } from '@givelify/utils';
import { Report } from 'store/report/types';
import { PaginatedResponse } from 'types/paginationTypes';

export const getReportHistory = (
    doneeId: number,
    pageSize: string,
    pageNumber: number,
    sortBy?: 'requestedByName' | 'createdAt',
    sortDirection?: 'asc' | 'desc',
): Promise<ApiResponse<PaginatedResponse<Report>>> => {
    let sorting = '';
    if (sortBy === 'requestedByName') {
        sorting = '&sort_by=requested_by_name';
    } else if (sortBy === 'createdAt') {
        sorting = '&sort_by=created_at';
    }

    let sortingDirection = '';
    if (sorting) {
        sortingDirection = `&sort_direction=${sortDirection || 'asc'}`;
    }

    const url = `/donees/${doneeId}/reports?&is_report&pageSize=${pageSize}&page=${
        pageNumber + 1
    }${sorting}${sortingDirection}`;

    const httpRequest = getAxiosClient().get(url);
    return makeApiRequest<PaginatedResponse<Report>>(httpRequest);
};
